<template>
    <svg viewBox="0 0 19 19" xmlns="http://www.w3.org/2000/svg">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0.585787 0.585786C1.36684 -0.195262 2.63317 -0.195262 3.41421 0.585786L9.50004 6.67161L15.5858 0.585871C16.3668 -0.195178 17.6332 -0.195178 18.4142 0.58587C19.1953 1.36692 19.1953 2.63325 18.4142 3.4143L12.3285 9.50004L18.4142 15.5858C19.1953 16.3668 19.1953 17.6332 18.4142 18.4142C17.6332 19.1953 16.3668 19.1953 15.5858 18.4142L9.50004 12.3285L3.41421 18.4143C2.63317 19.1953 1.36684 19.1953 0.585787 18.4143C-0.195262 17.6333 -0.195262 16.3669 0.585786 15.5859L6.67162 9.50004L0.585787 3.41421C-0.195262 2.63317 -0.195262 1.36683 0.585787 0.585786Z"
            fill="currentColor"
        />
    </svg>
</template>
